window.addEventListener("load", function () {
  const $grid = $("#frame4 .group__card .cards-grid");
  if (!$grid.length) return;

  const mqMobile = window.matchMedia("(max-width: 768px)");
  function pageSize() {
    return mqMobile.matches ? 12 : 10;
  }

  let currentTier = "all";
  let currentPage = 0;

  function visibleCards() {
    return $grid.find("> .card--item").filter(function () {
      return currentTier === "all" || $(this).data("tier") === currentTier;
    });
  }

  function totalPages() {
    return Math.max(1, Math.ceil(visibleCards().length / pageSize()));
  }

  function render() {
    const $all = $grid.find("> .card--item");
    $all.addClass("is-hidden");

    const $visible = visibleCards();
    const pages = totalPages();
    currentPage = Math.min(Math.max(currentPage, 0), pages - 1);

    const ps = pageSize();
    const start = currentPage * ps;
    $visible.slice(start, start + ps).removeClass("is-hidden");

    $("#frame4 .btn-prev").toggleClass("is-disabled", currentPage <= 0);
    $("#frame4 .btn-next").toggleClass(
      "is-disabled",
      currentPage >= pages - 1,
    );
    $("#frame4 .page-indicator .page-current").text(currentPage + 1);
    $("#frame4 .page-indicator .page-total").text(pages);
  }

  /* Filter buttons (btn__top) */
  $("#frame4 .group__top .btn__top").on("click", function (e) {
    e.preventDefault();
    currentTier = $(this).data("tier") || "all";
    currentPage = 0;
    $("#frame4 .group__top .btn__top").removeClass("is-active");
    $(this).addClass("is-active");
    render();
  });

  /* Pagination buttons */
  $("#frame4 .btn-next").on("click", function (e) {
    e.preventDefault();
    if (currentPage < totalPages() - 1) {
      currentPage++;
      render();
    }
  });
  $("#frame4 .btn-prev").on("click", function (e) {
    e.preventDefault();
    if (currentPage > 0) {
      currentPage--;
      render();
    }
  });

  if (mqMobile.addEventListener) {
    mqMobile.addEventListener("change", function () {
      currentPage = 0;
      render();
    });
  }

  render();
});
